define('modules/home/main/home.controller',[
    "client"
], function(
    Prospector)
{
    Prospector.module("HomeApp.Main", function(Main, Prospector, Backbone, Marionette, $, _){
        Main.Controller = {
            loadHome: function(options) {
                require(["modules/home/main/views/home.header.view"],
                    function(HomeHeaderView){
                        document.getElementsByTagName('title')[0].innerHTML = 'Home - RelPro &reg;';
                        if(Prospector.isFirstLoad && window.contract.isValid()){
                            var HeaderView = new HomeHeaderView();
                            $('.footer').append(HeaderView.render().el);
                            // Prospector.trigger("showTrialSubMenu");
                            Prospector.isFirstLoad = false;
                        }
                    });
            }
        }
    });
    return Prospector.HomeApp.Main.Controller;
});
